<template>
  <el-dialog v-model="isShow" width="600px" :close-on-click-modal='false' :close-on-press-escape='false'
    :show-close='false' destroy-on-close append-to-body>
    <div id="loader">
      <p>{{ text }}</p>
      <progress id="p" :value="setTimeVal" max="100"></progress>
      <output for="p">{{ setTimeVal }}</output>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'loadingproIndex',
  props: [],
  data: function () {
    return {
      isShow: false,
      text: '文件签署中，请稍后…',
      setTimeFile: null,
      setTimeVal: 0,
    }
  },
  methods: {
    upLoading(val) {
      this.setTimeVal = val
    },
    fromParent(pargam) {
      if (pargam.text) {
        this.text = pargam.text
      }
      if (pargam.isShow) {
        this.isShow = true
        // 有 schedule 是自定义进度
        if (pargam.schedule || pargam.schedule === 0) {
          this.setTimeVal = pargam.schedule
        } else {
          this.setTimeVal = 0
          this.fileProps(500)
        }
      } else {
        clearTimeout(this.setTimeFile)
        this.setTimeFile = null
        this.isShow = false
      }
    },
    fileProps(time) {
      let self = this;
      self.setTimeFile = setTimeout(function () {
        if (self.setTimeVal < 99) {
          self.setTimeVal++
          self.fileProps(self.setTimeVal < 30 ? time : 100)
        } else {
          clearTimeout(self.setTimeFile);
          self.setTimeFile = null;
        }
      }, time);
    },
  }
}
</script>

<style lang="scss" scoped>
#loader {
  display: flex;
  justify-content: center;
  align-items: center;
}

#loader {
  flex-direction: column-reverse;
  color: #8aaaff;
  font: 2.5em sans-serif;

  p {
    color: #999;
    font: 16px sans-serif !important;
  }
}

progress[value] {
  width: 12.5em;
  height: 0.25em;
  border: none;
  border-radius: 0.125em;
  background: #e6eeff;
}

progress[value]::-webkit-progress-bar {
  border: none;
  border-radius: 0.125em;
  background: #e6eeff;
}

progress[value]::-webkit-progress-value {
  border: none;
  border-radius: inherit;
  background: linear-gradient(90deg, #8aaaff, #fa8cff);
}

progress[value]::-moz-progress-bar {
  border: none;
  border-radius: inherit;
  background: linear-gradient(90deg, #8aaaff, #fa8cff);
}

progress[value]::-ms-fill {
  border: none;
  border-radius: inherit;
  background: linear-gradient(90deg, #8aaaff, #fa8cff);
}

output:not(:empty) {
  padding-bottom: 1em;
}

output:not(:empty):after {
  content: '%';
}

p:not(:empty) {
  padding-top: 3em;
}
</style>
